import { QuestionCircleOutlined } from '@ant-design/icons';
import { Col, Tooltip } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { ReactNode } from 'react';

import { Checkbox } from '../Checkbox';
import { FormItem } from '../Form';

type FormItemsCheckboxProps = {
  name: string | string[];
  label?: string;
  colSpan?: number;
  noStyle?: boolean;
  style?: React.CSSProperties;
  formItemsStyle?: React.CSSProperties;
  children?: ReactNode;
  onChange?: (e: CheckboxChangeEvent) => void;
  disabled?: boolean;
  tooltip?: ReactNode;
};

export function FormItemsCheckbox(props: FormItemsCheckboxProps) {
  const {
    name,
    label,
    colSpan,
    noStyle,
    style,
    formItemsStyle,
    children,
    onChange,
    disabled,
    tooltip,
  } = props;
  if (noStyle) {
    return (
      <FormItem
        name={name}
        label={label}
        noStyle={noStyle}
        valuePropName="checked"
      />
    );
  }
  return (
    <Col span={colSpan || 24} style={style}>
      {tooltip ? (
        <FormItem label={label} style={formItemsStyle}>
          <FormItem name={name} valuePropName="checked" noStyle>
            <Checkbox onChange={onChange} disabled={disabled}>
              {children}
            </Checkbox>
          </FormItem>
          <Tooltip title={tooltip} trigger={['hover', 'focus']}>
            <QuestionCircleOutlined
              aria-label="Ajuda"
              tabIndex={0}
              style={{ color: 'var(--neutral_medium)' }}
            />
          </Tooltip>
        </FormItem>
      ) : (
        <FormItem
          name={name}
          label={label}
          valuePropName="checked"
          style={formItemsStyle}
        >
          <Checkbox onChange={onChange} disabled={disabled}>
            {children}
          </Checkbox>
        </FormItem>
      )}
    </Col>
  );
}
